// extracted by mini-css-extract-plugin
export default {"betaFeatureTitle":"WorkpackSummary_betaFeatureTitle__zr8cR","betaFeatureStatus":"WorkpackSummary_betaFeatureStatus__VrUD4"};